export default __webpack_public_path__ + "static/media/Step1.a9c9cf88.svg";